import '../../../../../node_modules/@glidejs/glide/dist/css/glide.core.css'
import '../../../../../node_modules/@glidejs/glide/dist/css/glide.theme.css'
import Glide from '@glidejs/glide'

const who = {
  elThumbnailSlider: '',
  elContentSlider: '',
  elStaff: '',
  init() {
    this.staff()
    this.boats()
  },
  staff() {
    this.elStaff = $q('.bb-section--home-who .profile')

    if (!this.elStaff.first) return

    this.elStaff.listen('mouseenter', el => {
      el.classList.add('active')

      this.elStaff.loop(ael => ael.classList.remove('zindex'))
      el.classList.add('zindex')
    })
    this.elStaff.listen('mouseleave', el => {
      el.classList.remove('active')
    })
  },
  boats() {
    this.elThumbnailSlider = $q('.bb-section--home-who .thumbnail-slider')
    this.elContentSlider = $q('.bb-section--home-who .content-slider')

    if (!this.elThumbnailSlider.first || !this.elContentSlider) return

    const thumbnailSlider = new Glide(this.elThumbnailSlider.first).mount()
    const contentSlider = new Glide(this.elContentSlider.first).mount()

    thumbnailSlider.on('run', e => contentSlider.go(e.direction))
    contentSlider.on('run', e => thumbnailSlider.go(e.direction))
  }
}

export default who
